import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const FocusContext = createContext({ map: {}, focusOf: () => null, saveFocus: async () => {} });

export const DEFAULT_FOCUS = "50% 25%";

export function ImageFocusProvider({ children }) {
  const [map, setMap] = useState({});

  useEffect(() => {
    api.get("/image-focus").then((r) => setMap(r.data || {})).catch(() => {});
  }, []);

  const focusOf = useCallback((url) => (url ? map[url] || null : null), [map]);

  const saveFocus = useCallback(async (url, value) => {
    await api.put("/admin/image-focus", { url, value });
    setMap((m) => {
      const next = { ...m };
      if (value) next[url] = value;
      else delete next[url];
      return next;
    });
  }, []);

  const value = useMemo(() => ({ map, focusOf, saveFocus }), [map, focusOf, saveFocus]);
  return <FocusContext.Provider value={value}>{children}</FocusContext.Provider>;
}

export function useImageFocus() {
  return useContext(FocusContext);
}
